import { PDP_GTM_BLOCK_MONITOR } from './consts'

/**
 * List of experiments that are manually activated.
 *
 * Add experiment name here if experiment is something like aa test
 */
export default ['at-aa-feature', 'it-aa-feature', PDP_GTM_BLOCK_MONITOR]
